export default () => ({
  activePromo: {}
})
